import * as React from 'react';
import {Breadcrumb, Grid, Header, Segment, Table} from 'semantic-ui-react';
import i18n from '../../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
  ColumnSelectableComponentProps,
  ColumnSortableComponentProps,
  FilterObjectComponentProps,
  InfinityScrollComponentProps,
  ViewSettingsComponentProps,
  withColumnSelection,
  withColumnSort,
  withFilterObject,
  withInfinityScrollHandlers, withPrintAndExport,
  withViewSettings
} from '../../../components/DataTable/dataService';
import LoadingSpinner from '../../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../../components/DataTable/common';
import {formatCurrency} from '../../../utils/numbers';
import LoadingContainer from '../../../containers/LoadingContainer/LoadingContainer';
import RestClient from '../../../../../lib/RestClient';
import {useCallback, useEffect, useState} from 'react';

import queryString from 'query-string';
import {dateToIsoDateString} from '../../../utils/dates';
import Moment from 'react-moment';
import moment from 'moment';
import _get from "lodash/get";
import InfiniteScroll from "react-infinite-scroller";
import ExportContextHolder from "../../../../../lib/ExportContextHolder";
import {AnalyticsTracking} from "../../../components/AnalyticsTracking/AnalyticsTracking";
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    Line, LineChart, ReferenceLine,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";
import {MarketColors} from "../../../utils/colors";

const t = i18n.t.bind(i18n);

const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'bereich',
        labelTranslationKey: 'Sales.bereich',
        required: true
    },
  {
    fieldName: 'markt',
    labelTranslationKey: 'Sales.markt',
    required: true
  },
    {fieldName: 'martktName', labelTranslationKey: 'Sales.marktName', required: true},
    {
        fieldName: 'datum',
        labelTranslationKey: 'Sales.datum',
        required: true,
        cellRender: v => <Moment format={t("Common.DateFormat")}>{v}</Moment>,
        printExportRender: v => moment(v).format(t("Common.DateFormat"))
    },

  {fieldName: 'data.gesamtAnz', labelTranslationKey: 'Sales.anzahl', cellAlign: 'right'},
  {
    fieldName: 'data.gesamtWert',
    labelTranslationKey: 'Sales.gesamtWert',
    cellAlign: 'right',
    cellRender: v => formatCurrency(v || 0),
    printExportRender: v => formatCurrency(v || 0)
  }
];


const SalesBarChartValue = (props: {data: any}) => {

    const [data, setData] = useState<any[]>([]);
    const [selectedMarket, setSelectedMarket] = useState<string|null>(null);
    const [detailData, setDetailData] = useState<any[]>([]);

    useEffect( () => {

        let data: any[] = [];

        props.data.instances.forEach(
            (row:any) => {

                let dataRow: any = {};

                dataRow.name = row.markt + " " + row.marktName;
                dataRow.markt = row.markt;
                dataRow.V = row.gesamtWert;

                data.push(dataRow);
            }
        )

        data = data.sort( (a,b) => a.markt < b.markt ? -1 : 1)

        setData(data);
        }
    , [props.data]);

    useEffect(
        () => {
            if (selectedMarket === null) {
                setDetailData([]);
            } else {
                let data: any[] = [];

                props.data.instances.filter((row: any) => row.markt === selectedMarket)[0].instances.forEach(
                    (row:any) => {
                        let d: any = {};

                        d.markt = row.markt;
                        d.date = row.datum;
                        d.V = Math.round(row.gesamtWert * 1000) /1000;

                        data.push(d);
                    }
                );

                setDetailData(data.reverse());
            }
        }, [selectedMarket, props.data.instances]
    );


    const handleClick = useCallback(
        (data, index)=>{

            if (selectedMarket === data.markt) {
                setSelectedMarket(null);
            } else {
                setSelectedMarket(data.markt);
            }
        }
    , [selectedMarket]);

    return (
        <Segment raised>
            <Header as="h3">
                <Header.Content>{t("Sales.ValuePerMarket")}</Header.Content>
                <Header.Subheader>{t("Sales.ForField")} {props.data.bereich} {t("Fields." + props.data.bereich)}</Header.Subheader>
            </Header>
            <ResponsiveContainer width="100%" height={350}>
                <BarChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />

                    <Tooltip formatter={(v)=>formatCurrency(v.toString())}/>
                    <ReferenceLine y={0} stroke="#000" />
                    <Bar dataKey="V" label={false} name={""}  onClick={handleClick}>
                        {
                            data.map((entry, index) => (
                                //@ts-ignore
                                <Cell key={`cell-${index}`} fill={MarketColors[entry.markt]} />
                            ))
                        }
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            {detailData.length >0 ?

                <>
                    <Header as="h3">
                        <Header.Subheader>{t("Sales.OverviewForMarket")} {selectedMarket}</Header.Subheader>
                    </Header>


                    <ResponsiveContainer width="100%" height={350}>
                        <LineChart
                            width={500}
                            height={300}
                            data={detailData}
                            margin={{
                                top: 5, right: 30, left: 20, bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <Tooltip formatter={(v: any)=>formatCurrency(v)}/>
                            <ReferenceLine y={0} stroke="#000" />
                            <Line dataKey="V" stroke="#8884d8" activeDot={{ r: 8 }}>
                                {
                                    detailData.map((entry, index) => (
                                        //@ts-ignore
                                        <Cell key={`cell-${index}`} fill={MarketColors[entry.markt]} />
                                    ))
                                }
                            </Line>
                        </LineChart>
                    </ResponsiveContainer></> : <></>}
        </Segment>
    );
}

const SalesBarChartCount = (props: {data: any}) => {

    const [data, setData] = useState<any[]>([]);
    const [selectedMarket, setSelectedMarket] = useState<string|null>(null);
    const [detailData, setDetailData] = useState<any[]>([]);

    useEffect( () => {

            let data: any[] = [];

            props.data.instances.forEach(
                (row:any) => {

                    let dataRow: any = {};

                    dataRow.name = row.markt + " " + row.marktName;
                    dataRow.markt = row.markt;
                    dataRow.V = row.gesamtAnz;

                    data.push(dataRow);
                }
            )

            data = data.sort( (a,b) => a.markt < b.markt ? -1 : 1)

            setData(data);
        }
        , [props.data]
    );

    useEffect(
        () => {
            if (selectedMarket === null) {
                setDetailData([]);
            } else {
                let data: any[] = [];

                props.data.instances.filter((row: any) => row.markt === selectedMarket)[0].instances.forEach(
                    (row:any) => {
                        let d: any = {};

                        d.markt = row.markt;
                        d.date = row.datum;
                        d.V = row.gesamtAnz;

                        data.push(d);
                    }
                );

                setDetailData(data.reverse());
            }
        }, [selectedMarket, props.data.instances]
    );

    const handleClick = useCallback(
        (data, index)=>{

            if (selectedMarket === data.markt) {
                setSelectedMarket(null);
            } else {
                setSelectedMarket(data.markt);
            }
        }
        , [selectedMarket]);


    return (
        <Segment raised>
            <Header as="h3">
                <Header.Content>{t("Sales.SumPerMarket")}</Header.Content>
                <Header.Subheader>{t("Sales.ForField")} {props.data.bereich} {t("Fields." + props.data.bereich)}</Header.Subheader>
            </Header>
            <ResponsiveContainer width="100%" height={350}>
                <BarChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}

                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />

                    <Tooltip />
                    <ReferenceLine y={0} stroke="#000" />
                    <Bar dataKey="V" label={false} name={""}  onClick={handleClick}>
                        {
                            data.map((entry, index) => (
                                //@ts-ignore
                                <Cell key={`cell-${index}`} fill={MarketColors[entry.markt]} />
                            ))
                        }
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            {detailData.length >0 ?

            <>
            <Header as="h3">
                <Header.Subheader>{t("Sales.OverviewForMarket")} {selectedMarket}</Header.Subheader>
            </Header>


            <ResponsiveContainer width="100%" height={350}>
                <LineChart
                    width={500}
                    height={300}
                    data={detailData}
                    margin={{
                        top: 5, right: 30, left: 20, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <ReferenceLine y={0} stroke="#000" />
                    <Line dataKey="V" stroke="#8884d8" activeDot={{ r: 8 }}>
                        {
                            detailData.map((entry, index) => (
                                //@ts-ignore
                                <Cell key={`cell-${index}`} fill={MarketColors[entry.markt]} />
                            ))
                        }
                    </Line>
                </LineChart>
            </ResponsiveContainer></> : <></>}

        </Segment>
    );
}

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const SalesSupplierArticleDetails = (props: {dateFrom?: Date; dateTo?: Date; marketName?: string} & RouteComponentProps<{account: string; sorteNr2: string; farbeNr: string; laenge: string;}> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {
  if(props.loadingInitial || !props.data) {
    return <LoadingContainer showLogo={false}/>;
  }

    let data: any = props.data;

    let rows =  data.instances && data.instances.length > 0 ? (
            <>
                {data.instances.map((row: any, idx: any) =>
                    <>
                        {row.instances.map((row_: any, idx: any) =>
                            <>
                                {row_.instances.map((row__: any, idx: any) =>
                                    <>
                                        <Table.Row>
                                            <Table.Cell className={"responsive"}>{row__.bereich} {t("Fields." + row__.bereich)}</Table.Cell>
                                            <Table.Cell className={"responsive"}>{row__.markt}</Table.Cell>
                                            <Table.Cell className={"responsive"}>{row__.marktName}</Table.Cell>
                                            <Table.Cell className={"responsive"}>{row__.datum}</Table.Cell>
                                            <Table.Cell className={"responsive alignRight"}>{row__.gesamtAnz}</Table.Cell>
                                            <Table.Cell className={"responsive alignRight"}>{(row__.gesamtWert + 0.0001).toFixed(2)  || "0.00"}</Table.Cell>
                                        </Table.Row>
                                    </>)
                                }

                                <Table.Row style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>

                                    <Table.Cell></Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell className={"responsive"}>
                                        <b>{t("Sales.sum_markt")} ({row_.markt + " " +  row_.marktName}):</b>
                                    </Table.Cell>
                                    <Table.Cell></Table.Cell>
                                    <Table.Cell className={"responsive alignRight"}>
                                        {row_.gesamtAnz}
                                    </Table.Cell>
                                    <Table.Cell className={"responsive alignRight"}>
                                        {(row_.gesamtWert + 0.0001).toFixed(2) || "0.00"}
                                    </Table.Cell>
                                </Table.Row>
                            </>)
                        }

                        <Table.Row style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>

                            <Table.Cell className={"responsive alignRight"} colspan={2}>
                                <b>{t("Sales.sum_field")} ({row.bereich} {t("Fields." + row.bereich)}):</b>
                            </Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell></Table.Cell>

                            <Table.Cell className={"responsive alignRight"}>
                                {row.gesamtAnz}
                            </Table.Cell>
                            <Table.Cell className={"responsive alignRight"}>
                                {(row.gesamtWert + 0.0001).toFixed(2)  || "0.00"}
                            </Table.Cell>
                        </Table.Row>
                    </>

                )}



              <Table.Row key={"lastRow"} style={{backgroundColor: "rgb(249, 250, 251)", color: "rgba(0,0,0,.87)"}}>
                  <Table.Cell className={"responsive"}>
                      <b>{t("Sales.sum")}:</b>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell></Table.Cell>
                  <Table.Cell className={"responsive alignRight"}>{data.gesamtAnz}</Table.Cell>
                  <Table.Cell className={"responsive alignRight"}>
                   {data.gesamtWert.toFixed(2)}
                  </Table.Cell>
              </Table.Row>
            </>): <></>;

        ExportContextHolder.enabled = true;
        ExportContextHolder.loadFunctionV2 = (page: number, size: number): Promise<{page: number; totalPages: number; rows: any[]}> =>{
            return new Promise(
                (resolve, reject) => {
                    // Workaround for CSV Export in sales views
                  // TODO: refactor
                    let tempRows = [];
                    try {
                      const dataRows = data.instances.flatMap((d:any) => d.instances).flatMap((d:any) => d.instances).flatMap((d:any) => d.instances).flatMap((d:any) => d.instances);
                      for(let objectRow of dataRows) {
                        let arrayRow = [];
                        for (let column of COLUMNS) {
                          const cellContent = column.printExportRender ? column.printExportRender(_get(objectRow, column.fieldName), objectRow, {}) : _get(objectRow, column.fieldName);
                          arrayRow.push(cellContent || '');
                        }
                        tempRows.push(arrayRow);
                      }
                    }catch(e) {
                      // do not crash when something does not work
                    }

                    resolve(
                        {
                            page: 0,
                            totalPages: 1,
                            rows: tempRows
                        })
                }
            );
        };
        ExportContextHolder.rowsToRender = rows;
        ExportContextHolder.routeData = [`${t("Route.Sales")} ${t("Route.SalesSupplier")}`,`${t("Sales.Suplier")}: ${props.match.params.account} ` ,`${t("Sales.article")}: ${props.match.params.sorteNr2 + props.match.params.farbeNr + " - " + data.beschreibung};`];
        ExportContextHolder.fields = COLUMNS.map(c => c.labelTranslationKey? t(c.labelTranslationKey) : c.label);
        ExportContextHolder.reloadHeaderFunc();

  return (
      <>
        <AnalyticsTracking page="sales/supplier-article/details" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>
            <h3><Breadcrumb icon="right angle" sections={[
              {
                key: '1',
                as: NavLink,
                to: '/sales/supplier-article',
                content: `${t("Route.Sales")} ${t("Route.SalesSupplierArticle")}`, link: true
              },
              {key: '2',
                content: `${t("Sales.zuechter")}: ${props.match.params.account}; ${t("Sales.article")}: ${props.match.params.sorteNr2 + props.match.params.farbeNr + " - " + data.beschreibung}; ${t("Sales.length")}: ${props.match.params.laenge}`,
                active: true
              },

            ]}/></h3>
            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
            {props.dateFrom && <><strong>{t("Common.DateFrom")}:</strong> <Moment element={"span"} format={t("Common.DateFormat")}>{props.dateFrom.toISOString()}</Moment></>}
            {props.dateTo && <> <strong>{t("Common.DateTo")}:</strong> <Moment element={"span"} format={t("Common.DateFormat")}>{props.dateTo.toISOString()}</Moment></>}
            <Grid columns={3} className={"HeadingGrid"} stackable={true}
                  style={{marginBottom: '1em'}}>
              <Grid.Column width={7}>
              </Grid.Column>
                <Grid.Column width={1}>
                    <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                        <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                        </div>
                    </div>
                </Grid.Column>
            </Grid>
          </div>
        </div>


        <div className={"ui container responsivewrapper"}>

            <Table>
                <Table.Header className={"sticky-header"}>
                    <Table.Row key="0">

                        { COLUMNS.map( (c, idx)=>
                            <Table.HeaderCell
                            >{c.labelTranslationKey? t(c.labelTranslationKey) : c.label}</Table.HeaderCell>
                        )}
                    </Table.Row>
                </Table.Header>

                <InfiniteScroll
                    element="tbody"
                    pageStart={0}
                    loadMore={props.loadMore}
                    hasMore={false}
                    threshold={1000}
                    useWindow={false}
                >
                    {rows}
                </InfiniteScroll>

            </Table>
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>

        <Grid>
            <Grid.Row>
                <Grid.Column width={8}>
                    {
                        data && data.instances ? data.instances.map(
                            (fieldRow: any) => <SalesBarChartCount data={fieldRow}></SalesBarChartCount>
                        ):<></>
                    }
                </Grid.Column>
                <Grid.Column width={8}>
                    {
                        data && data.instances ? data.instances.map(
                            (fieldRow: any) => <SalesBarChartValue data={fieldRow}></SalesBarChartValue>
                        ):<></>
                    }
                </Grid.Column>
            </Grid.Row>
        </Grid>

      </>
  )
};

const WrappedComponent = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(SalesSupplierArticleDetails)))))));

export default (props: RouteComponentProps<{account: string;sorteNr2: string; farbeNr: string; laenge: string;}>) => {
  const [dateState, setDateState] = useState({dateFrom: undefined, dateTo: undefined} as {dateFrom?: Date; dateTo?: Date});

  useEffect(() => {
    const searchQuery = props.location.search;
    console.log('Reading parameter ' + searchQuery);
    if(searchQuery !== null && searchQuery!== '') {
      const parsed = queryString.parse(searchQuery);
      setDateState({
        dateFrom: parsed.dateFrom ? new Date(parsed.dateFrom) : undefined,
        dateTo: parsed.dateTo ? new Date(parsed.dateTo) : undefined
      });
    }
  }, [props.location.search]);


  const dataService = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }, size?: number): Promise<any> {

        return RestClient.get(`sales/supplier-article/${props.match.params.account}/${props.match.params.sorteNr2}/${props.match.params.farbeNr}/${props.match.params.laenge}`, {
                    date: '',
                    filter: filter.filter,
                    dateFrom: dateState.dateFrom ? dateToIsoDateString(dateState.dateFrom) : '',
                    dateTo: dateState.dateTo ? dateToIsoDateString(dateState.dateTo) : '',
                    count: size || 50
                });
    }
  };
  return (
      <WrappedComponent
          viewName="sales_details_supplier_article"
          dateFrom={dateState.dateFrom}
          dateTo={dateState.dateTo}
          dataService={dataService}
          defaultSortDirection="DESC"
          defaultSortColumn="data.bewegungsDatum"
          defaultColumns={DEFAULT_COLUMNS}
          defaultFilter={{
          }}
          printColumns={COLUMNS}
          printPath = {[`${t("Route.Sales")} ${t("Route.SalesSupplier")}`,`${t("Sales.article")}: ${props.match.params.sorteNr2 + props.match.params.farbeNr}; ` ,`${t("Sales.length")}: ${props.match.params.laenge}; `]}
      />
  );

}